var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"error"}},[_vm._v(" 404未找到该页面！请先配置路由 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }